import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessFunctionParameter } from './process-function-parameter';
export { ProcessFunctionParameter };
import { processFunctionParameterSchema } from '@schemas/business-objects/process-function-parameter';
import { ProcessDataTypeFormGroup } from './process-data-type-form-group';
import { ProcessFunctionFormGroup } from './process-function-form-group';

export class ProcessFunctionParameterFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    isArray: SchemaFormControl;
    sequence: SchemaFormControl;
    description: SchemaFormControl;
    functionId: SchemaFormControl;
    function: ProcessFunctionFormGroup;
    typeId: SchemaFormControl;
    type: ProcessDataTypeFormGroup;
  };

  declare value: Partial<ProcessFunctionParameter>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      processFunctionParameterSchema,
      ProcessFunctionParameter,
      data,
      options,
    );
  }

  get object(): ProcessFunctionParameter {
    return new ProcessFunctionParameter(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'function':
        return new ProcessFunctionFormGroup();
      case 'type':
        return new ProcessDataTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessFunctionParameter[]> {
    return ProcessFunctionParameter.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessFunctionParameter | null> {
    return ProcessFunctionParameter.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessFunctionParameter> {
    return ProcessFunctionParameter.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessFunctionParameter>,
  ): Promise<ProcessFunctionParameter> {
    return ProcessFunctionParameter.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessFunctionParameter>,
  ): Promise<ProcessFunctionParameter> {
    return ProcessFunctionParameter.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessFunctionParameter.deleteById(id);
  }
}

export class ProcessFunctionParameterFormArray extends PersistedFormArray {
  declare controls: ProcessFunctionParameterFormGroup[];

  readonly entityName = 'ProcessFunctionParameter' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processFunctionParameterSchema, ProcessFunctionParameter, options);
  }

  protected override createItemGroup() {
    return new ProcessFunctionParameterFormGroup();
  }

  get array(): ProcessFunctionParameter[] {
    return this.controls.map(
      (group: ProcessFunctionParameterFormGroup) => group.object,
    );
  }
}

export class ProcessFunctionParameterPersistedArray extends PersistedArray<ProcessFunctionParameter> {
  readonly entityName = 'ProcessFunctionParameter' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessFunctionParameter, options);
  }
}
